<template>
  <div class="bottom-router" :style="{paddingBottom:iPhoneX ? '12px':'0'}">
    <div class="bottomRouter-main">
      <div class="bottomRouter-main-item" @click="changePage('index')">
        <div>
          <img  v-if="page == 'index'" src="../../assets/img/common/index-active.svg" alt="">
          <img v-else src="../../assets/img/common/index-default.svg" alt="">
        </div>
        <p :class="[page == 'index' ? 'active' : '']">首页</p>
      </div>
      <div class="bottomRouter-main-item" @click="changePage('ade')">
        <div>
          <img src="../../assets/img/common/ade-default.svg" alt="">
        </div>
        <p>有赚</p>
      </div>
      <div class="bottomRouter-main-item" @click="changePage('data')">
        <div>
          <img src="../../assets/img/common/data-default.svg" alt="">
        </div>
        <p>有数</p>
      </div>
      <div class="bottomRouter-main-item" @click="changePage('user')">
        <div>
          <img v-if="page == 'user'" src="../../assets/img/common/user-active.svg" alt="">
          <img v-else src="../../assets/img/common/user-default.svg" alt="">
        </div>
        <p :class="[page == 'user' ? 'active' : '']">
          我的
        </p>
        <div class="noticetips" v-if="noticeprompt" :style="promptstyle">{{noticecount}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import {getUserNoticeCount} from '@/assets/js/api/index.js'
  export default {
    name: 'BottomRouter',
    props: ['page'],
    data() {
      return {
        iPhoneX:false,
        noticeprompt:false,
        noticecount:0,
        promptstyle:"",
      }
    },
    created() {
      if(this.isIphoneX()){
        this.iPhoneX = true
      };
      getUserNoticeCount((data)=>{
        if(data > 0){
          this.noticeprompt = true;
          if(data > 99){
            this.noticecount = "...";
            this.promptstyle = "line-height:12px;"
          }else{
            this.noticecount = data;
          }
        }
      })
    },
    methods: {
      changePage (p){
        if(p == 'index' && p != this.page){
          this.$router.push({name:'Index'})
        }else if(p == 'user' && p != this.page){
          this.$router.push({name:'Info'})
        }else if(p == 'ade' && p != this.page){
          window.location.href = 'https://a.newrank.cn/phone/trade?trackType=1&trackChannel=10&trackScene=999'
        }else if(p == 'data' && p != this.page){
          window.location.href = 'http://data.newrank.cn'
        }
      },
      isIphoneX (){
        return /iPhone/g.test(navigator.userAgent) && (screen.height == 812 && screen.width == 375)
      },
    }
  }
</script>

<style lang="css" scoped>
  p.active{
    color: #FF7800;
  }
  .bottom-router{
    background-color: #fff;
    position: fixed;
    z-index: 999;
    bottom: 0;
    height: 50px;
    width: 100%;
    border-top: 1px solid #E3E3E3;
  }
  .bottomRouter-main{
    width: 100%;
    height: 100%;
    padding: 0 7px;
    display: flex;
    box-sizing: border-box;
  }
  .bottomRouter-main-item{
    flex: 1;
    font-size: 10px;
    color: #999;
    padding-top: 7px;
    text-align: center;
    position: relative;
  }
  .bottomRouter-main-item p{
    line-height: 14px;
  }
  .bottomRouter-main-item div{
    height: 25px;
  }
  .bottomRouter-main-item div img{
    width: 20px;
  }
  .bottomRouter-main-item .noticetips{
    position: absolute;
    width:18px;
    height:18px;
    line-height: 18px;
    text-align: center;
    border-radius:50%;
    color: #fff;
    font-size:10px;
    background:rgba(255,100,100,1);
    top: 5px;
    right: 18px;
  }
</style>



// WEBPACK FOOTER //
// bottomRouter.vue?01ba4d66